import { httpApi } from '@app/api/http.api'

export interface AlarmRequest {
  name: string
  type: string
  alarmsDetailsList: AlarmDetails[]
}

export type AlarmDetails = {
  id?: string
  alarmId?: string
  language: string
  code: string
  description: string
  solution: string
  createdAt?: string
  updatedAt?: string
}

export type GetAlarmResponse = {
  id: string
  name: string
  type: string
  isDeleted: boolean
  createdAt: string
  updatedAt: string
  alarmsDetailsList: AlarmDetails[]
}

export interface BaseAlarm {
  id: string
  name: string
}
export interface AlarmTableItem extends BaseAlarm {
  type: string
}

export type DeviceAlarmDetails = {
  createdAt: Date
  alarmDeviceConnection: {
    dataType: string
    index: number
  }
  resolvedDate: Date
  confirmedDate: Date
  alarmDetails: {
    description: string
    language: string
    messageId: number
    solution: string
  }[]
}

const ALARMS = 'alarms'

export const getAlarm = (id: string): Promise<GetAlarmResponse> =>
  httpApi.get<GetAlarmResponse>(`${ALARMS}/${id}`).then(({ data }) => data)

export const createAlarm = (createInverterPayload: AlarmRequest): Promise<GetAlarmResponse> =>
  httpApi.post<GetAlarmResponse>(`${ALARMS}/create-alarm`, { ...createInverterPayload }).then(({ data }) => data)

export const updateAlarm = (id: string, updateAlarmPayload: AlarmRequest): Promise<GetAlarmResponse> => {
  return httpApi
    .put<GetAlarmResponse>(`${ALARMS}/update-alarm/${id}`, { ...updateAlarmPayload })
    .then(({ data }) => data)
}

export const deleteAlarmInfo = (id: string): Promise<GetAlarmResponse> =>
  httpApi.delete<GetAlarmResponse>(`${ALARMS}/${id}`).then(({ data }) => data)

export const getAllAlarmsTable = (): Promise<AlarmTableItem[]> =>
  httpApi.get<AlarmTableItem[]>(`${ALARMS}/all-table`).then(({ data }) => data)

export const getAllAlarmsDeviceForm = (): Promise<AlarmTableItem[]> =>
  httpApi.get<AlarmTableItem[]>(`${ALARMS}/all-device-form`).then(({ data }) => data)

export const getDeviceAlarmDetails = (id: string, language: string): Promise<DeviceAlarmDetails> =>
  httpApi.get<DeviceAlarmDetails>(`${ALARMS}/alarm-details/${id}`, { params: { language } }).then(({ data }) => data)
